<div class="container-fluid-modal">

  <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm()" novalidate>

    <div class="edit">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Profile</h4>
        <div class="headerButton">
          <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save </button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
        </div>
      </div>
            <mat-dialog-content>
		        <div class="card">
		          <div class="card-body">

		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="First Name" class="labelRequired">First Name </label>
		                <input type="text" class="form-control" placeholder="First Name" name="firstName" [(ngModel)]="userData.first_name"
		                       required #firstName="ngModel" [ngClass]="{'has-danger':firstName?.invalid && firstName?.touched }">
		                <div *ngIf="firstName?.errors && (firstName?.dirty || firstName?.touched)">
		                  <div [hidden]="!firstName.errors.required" class="formError"> * First Name is required</div>
		                </div>
		              </div>
		            </div>

		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="Last Name" class="labelRequired">Last Name </label>
		                <input type="text" class="form-control" placeholder="Last Name" name="lastName" [(ngModel)]="userData.last_name"
		                       required #lastName="ngModel" [ngClass]="{'has-danger':lastName?.invalid && lastName?.touched }">
		                <div *ngIf="lastName?.errors && (lastName?.dirty || lastName?.touched)">
		                  <div [hidden]="!lastName.errors.required" class="formError"> * Last Name is required</div>
		                </div>
		              </div>
		            </div>

		            <div class="form-group col-lg-12">
		              <div class="form-group col-lg-12">
		                <label for="email" class="labelRequired">Email</label>
		                <input type="text" class="form-control" placeholder="Email" name="email" [(ngModel)]="userData.email"
		                       required #email="ngModel" [ngClass]="{'has-danger':email?.invalid && email?.touched }">
		                <div *ngIf="email?.errors && (email?.dirty || email?.touched)">
		                  <div [hidden]="!email.errors.required" class="formError"> * Email is required</div>
		                </div>
		              </div>
		            </div> 

		          </div>

		        </div>

      	</mat-dialog-content>
    </div>

  </form>
</div>
